import { Component, EventEmitter, Input, Output } from '@angular/core';
import {AssetVersionPipe} from '../../../../../pipes/asset-version.pipe';


@Component({
  selector: 'app-group-header',
  standalone: true,
  imports: [
    AssetVersionPipe
  ],
  templateUrl: './group-header.component.html',
  styleUrl: './group-header.component.scss',
})
export class GroupHeaderComponent {
  @Input({ required: true }) label!: string;

  @Input({ required: true }) groupId!: string;

  @Output() findInChat = new EventEmitter<string>();

  onFindInChat(): void {
    this.findInChat.emit(this.groupId);
  }
}
